import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useTransition } from 'react';

var TabPane = function TabPane(_ref) {
  var index = _ref.index,
      currentIndex = _ref.currentIndex,
      children = _ref.children;

  var _useState = useState(function () {
    return index === currentIndex;
  }),
      isActive = _useState[0],
      setActive = _useState[1];

  var _useState2 = useState(function () {
    return isActive;
  }),
      inited = _useState2[0],
      setInited = _useState2[1];

  var _useTransition = useTransition(),
      startTransition = _useTransition[1];

  useEffect(function () {
    startTransition(function () {
      setActive(index === currentIndex);
    });
  }, [index, currentIndex]);
  useEffect(function () {
    if (isActive && !inited) {
      setInited(true);
    }
  }, [isActive, inited]);
  return _jsx("div", Object.assign({
    style: {
      display: isActive ? 'block' : 'none'
    }
  }, {
    children: inited && children
  }));
};

export default TabPane;